module.exports = __webpack_public_path__ + "img/Schreinerin-JK-129.29761825.jpg";